import * as React from "react";
const SvgFiRrAperture = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-aperture_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m1.409 2.1A10 10 0 0 1 19.995 6h-8.962zm.783 5.899 2.433 4.005L14.189 16H9.744l-2.308-4.101 2.378-3.901zm-3.088-5.957L6.312 9.903 4.07 5.919a10 10 0 0 1 7.034-3.877M2.836 16A9.9 9.9 0 0 1 2 12a9.9 9.9 0 0 1 .885-4.111L7.45 16zm7.755 5.9A10 10 0 0 1 4.005 18h8.964zm2.306.059 4.896-8.031 2.35 3.87a10 10 0 0 1-7.246 4.161m3.634-13.96h4.633A9.95 9.95 0 0 1 22 12a9.9 9.9 0 0 1-.743 3.78z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-aperture_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAperture;
